/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GoalTypeList = {
    type: 'array',
    contains: {
        type: 'GoalType',
    },
} as const;
